import {
  CountryCode,
  CurrencyCode,
  IsdCode,
  LocaleCode,
} from "constants/enums";
import { formatIsdDropdownLabel } from "constants/omsRegionConfig";
import { DEFAULT_ISD_CODE } from "constants/phoneConfig";

export const COUNTRY_MAPPINGS = [
  {
    countryId: 1,
    countryCode: CountryCode.IND,
    countryName: "India",
    isdCode: IsdCode.INDIA,
    currencyCode: CurrencyCode.INR,
    locale: LocaleCode.EN_IN,
  },
  {
    countryId: 2,
    countryCode: CountryCode.BHR,
    countryName: "Bahrain",
    isdCode: IsdCode.BAHRAIN,
    currencyCode: CurrencyCode.BHD,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 3,
    countryCode: CountryCode.KWT,
    countryName: "Kuwait",
    isdCode: IsdCode.KUWAIT,
    currencyCode: CurrencyCode.KWD,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 4,
    countryCode: CountryCode.QAT,
    countryName: "Qatar",
    isdCode: IsdCode.QATAR,
    currencyCode: CurrencyCode.QAR,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 5,
    countryCode: CountryCode.OMN,
    countryName: "Oman",
    isdCode: IsdCode.OMAN,
    currencyCode: CurrencyCode.OMR,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 6,
    countryCode: CountryCode.SAU,
    countryName: "Saudi Arabia",
    isdCode: IsdCode.SAUDI_ARABIA,
    currencyCode: CurrencyCode.SAR,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 7,
    countryCode: CountryCode.ARE,
    countryName: "United Arab Emirates",
    isdCode: IsdCode.UAE,
    currencyCode: CurrencyCode.AED,
    locale: LocaleCode.EN_US,
  },
  {
    countryId: 8,
    countryCode: CountryCode.USA,
    countryName: "United States of America",
    isdCode: IsdCode.USA,
    currencyCode: CurrencyCode.USD,
    locale: LocaleCode.EN_US,
  },
];

/** ISD codes shown in the customer-search phone dropdown. GCC goes live later. */
export const PHONE_INPUT_ISD_CODES = [
  IsdCode.INDIA,
  IsdCode.USA,
  // IsdCode.BAHRAIN,
  // IsdCode.KUWAIT,
  // IsdCode.QATAR,
  // IsdCode.OMAN,
  // IsdCode.SAUDI_ARABIA,
  // IsdCode.UAE,
];

export const getCountryByIsdCode = (isdCode) =>
  COUNTRY_MAPPINGS.find((country) => country.isdCode === isdCode) || null;

export const getCountryByCountryCode = (countryCode) =>
  COUNTRY_MAPPINGS.find((country) => country.countryCode === countryCode) ||
  null;

export const getDefaultCountry = () =>
  getCountryByIsdCode(DEFAULT_ISD_CODE) || COUNTRY_MAPPINGS[0];

export const getPhoneInputCountries = () =>
  COUNTRY_MAPPINGS.filter((country) =>
    PHONE_INPUT_ISD_CODES.includes(country.isdCode),
  );

/** Compact phone-field options: flag + ISD (e.g. 🇮🇳 +91). */
export const toIsdSelectOptions = (countries = []) =>
  countries.map((country) => ({
    id: country.countryId,
    value: country.countryCode,
    label: formatIsdDropdownLabel(country.isdCode),
  }));
